/**
 * Bir Blob'u dosya olarak indirir. Tüm rapor export'ları bu yardımcıyı paylaşır.
 * format -> uzantı eşlemesi: PDF -> .pdf, EXCEL -> .xlsx.
 */
export function downloadBlob(blob: Blob, fileName: string, format: 'PDF' | 'EXCEL'): void {
  const extension = format === 'PDF' ? 'pdf' : 'xlsx';
  const finalName = fileName.toLowerCase().endsWith(`.${extension}`)
    ? fileName
    : `${fileName}.${extension}`;

  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = finalName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(url);
}
